import { DeserializedCompanyBusinessUnit, PRICING_REFERENCE_OPTIONS } from '@/src/lib/company-business-units/types';
import { SelectOption } from '@/src/types/select-option';
import { Dictionary } from '@/src/lib/dictionary/types';
import { PRICING_REFERENCE_NONE } from '@/src/app/components/Header/AccountCards/lib/account-card-helpers';

export function assemblePricingReferenceOptions(
  companyBusinessUnit: DeserializedCompanyBusinessUnit | undefined,
  dict: Dictionary,
): Array<SelectOption> {
  if (!companyBusinessUnit) {
    return [];
  }

  const projectNumberOptions = companyBusinessUnit.priceReferenceProjectNumbers?.map((projectNumber) => ({
    label: projectNumber,
    value: `${PRICING_REFERENCE_OPTIONS.PROJECT}-${projectNumber}`,
  }));

  const quoteNumberOptions = companyBusinessUnit.priceReferenceQuoteIds?.map((quoteNumber) => ({
    label: quoteNumber,
    value: `${PRICING_REFERENCE_OPTIONS.QUOTE}-${quoteNumber}`,
  }));

  const options = [...(projectNumberOptions || []), ...(quoteNumberOptions || [])];

  options.unshift({ label: dict.userProfile.selectOptionNone, value: PRICING_REFERENCE_NONE });

  return options;
}
